import { Component, OnInit, Injector } from '@angular/core';
import { TableAbstractComponent } from 'src/app/common-page-components/classes/table-abstract-component';
import { FiltersAthleteBiographyService } from '../services/filters-athlete-biography.service';
import { AthleteBiographyStore, Positions, Col, BioField } from '../../../common-page-components/stores/entities-store/athlete-biography-store';
import { HttpClient } from '@angular/common/http';
import { FiltersAthleteGeneralService } from '../../services/filters-athlete-general.service';
import { filter, withLatestFrom, mergeMap, first } from 'rxjs/operators';
import { flatten } from 'src/app/officials/components/bootstrap-officials/bootstrap-officials.component';

@Component({
  selector: 'app-boostrap-athlete-biography',
  templateUrl: './boostrap-athlete-biography.component.html',
  styleUrls: ['./boostrap-athlete-biography.component.scss']
})
export class BoostrapAthleteBiographyComponent extends TableAbstractComponent {

  constructor(injector: Injector,
    filter_service: FiltersAthleteBiographyService,
    http: HttpClient,
    public common_service: FiltersAthleteGeneralService) {
    super(injector, filter_service, common_service.athleteDetailStore);
  }

  /**
 * Build headers of this page.
 *
 * The headers are different when isn't a selected category.
 */
  headers() {
    const headers = [
      { name: 'Date', isSortable: false, sortProperty: 'DATE' },
      { name: 'Title', isSortable: false, sortProperty: 'NAME' },
      { name: 'Organisation', isSortable: false, sortProperty: 'NOC' },
    ];
    return headers;
  }

  /**
   * Get positions mapped to array for use in table
   *
   * @returns
   * @memberof BoostrapAthleteBiographyComponent
   */
  getPositions() {
    if (this.data && this.data[0]) {
      return this.common_service.getAthletePositions(this.data);
    } else {
      return []
    }
  }

  /**
   * Method for get the start date of position
   *
   * @param {string} start the string date
   * @returns
   * @memberof BoostrapAthleteBiographyComponent
   */
  getDateStartPosition(start: string) {
    return typeof new Date(start).getFullYear() !== 'number' ? '' : new Date(start).getFullYear();
  }

  /**
   * Method for get the end date or 'Present' of position
   *
   * @param {string} end the string date
   * @returns
   * @memberof BoostrapAthleteBiographyComponent
   */
  getDateEndPosition(end: string) {
    const endDate = new Date(end);
    const isNumber = Number.isNaN(endDate.getTime()) === false;
    return isNumber ? (endDate > new Date() ? 'Present' : endDate.getFullYear()) : 'Present';
  }

  /**
   * A method for check if the years are in array or are individual and render them propertly.
   *
   * @param {Array} data
   * @returns
   * @memberof BoostrapAthleteBiographyComponent
   */
  isArrayYears(data: Array<any>) {
    if (data instanceof Array) {
      return data.join(', ');
    } else {
      return false;
    }
  }

  /**
   *
   *
   * @memberof BoostrapAthleteBiographyComponent
   */
  getOrganisationFromPosition(position: Col) {
    if (position.type === 'WA') {
      return 'World Archery'
    }
    if (position.type === 'WAAm') {
      return 'Continental Association';
    }
    return this.model.dependencies[0].entity.data.find(value => value.NOC === position.type).CShort;
  }

  /**
   * A method for get the information of the biography fields using the id
   *
   * @param {string} id
   * @memberof BoostrapAthleteBiographyComponent
   */
  getInformationOfBiography(id: string) {
    const info = this.data[0].BioFields != null ? this.data[0].BioFields.find(value => value.BioId.toString() === id.toString()) : '';
    return { Value: info !== '' && info ? info.Value : undefined };
  }

  /**
   * Method for get the name of the country
   *
   * @param {string} NOC
   * @returns
   * @memberof BoostrapAthleteBiographyComponent
   */
  getCountryName(NOC: string) {
    return this.model.dependencies[0].entity.data.find(value => value.NOC === NOC).CShort;
  }

  /**
  * Getter for observe the athlete id.
  *
  * @readonly
  * @memberof BoostrapAthleteBiographyComponent
  */
  get athleteId() {
    return this.common_service.storedId.asObservable().filter(value => value != undefined)
  }
  /**
  * Getter for obtain the editorial infomation from the service.
  *
  * @readonly
  * @memberof BoostrapAthleteBiographyComponent
  */
  get editorialAthleteBiography() {
    return this.common_service.athleteEditorialBiographyStore;
  }

}
